import { createUseStyles } from 'react-jss'
import { GRAY, MINT_GREEN } from '@omnilert/components'

export default createUseStyles({
  button: {
    border: 'none',
    padding: '0',
    marginRight: '8px'
  },
  carouselItem: {
    backgroundColor: ({ itemIsSelected }) => itemIsSelected ? MINT_GREEN : 'var(--primary__page__background)',
    border: ({ itemIsSelected }) => itemIsSelected ? `1px solid ${MINT_GREEN}` : `1px solid ${GRAY}`,
    opacity: ({ actionTaken, itemIsSelected }) => actionTaken?.length > 0 && !itemIsSelected ? 0.4 : 1,
    borderRadius: 20,
    color: 'var(--chat-bubble__text__color)',
    display: 'flex',
    flexDirection: 'column',
    height: '140px',
    width: 250,
    padding: '1em',
    whiteSpace: 'pre-line',
    wordBreak: 'break-word',
    '&:hover': {
      cursor: ({ actionTaken }) => actionTaken?.length > 0 ? 'not-allowed' : 'pointer'
    }
  },
  description: {
    fontSize: '14px',
    fontFamily: 'BentonSansRegular',
    marginBottom: '8px',
    padding: 5
  },
  title: {
    fontSize: '16px',
    fontFamily: 'BentonSansBold',
    marginBottom: '8px'
  },
  icon: {
    marginBottom: '8px',
    '& svg': {
      width: '20px',
      height: '20px'
    }
  }
})
